import type { IsoDate } from '@erikdakoda/i18n/shared/date';

/**
 * Builds the canonical MetricValue.sourceId for every metric connector.
 * Format: `{source}:{sourceType}:{localDay}`. `sourceType` may itself contain
 * colons (e.g. `heartRate:average` or `daily_activity:steps`).
 * @param source MetricValue.source (provider slug).
 * @param sourceType Provider-specific series key (endpoint, data type, metric slug, …).
 * @param localDay ISO calendar day for the sample.
 */
export function buildMetricSampleSourceId(
  source: string,
  sourceType: string,
  localDay: IsoDate | string,
): string {
  return `${source}:${sourceType}:${localDay}`;
}
